import styled from '@emotion/styled';

export const NaturalPersonListPageContainer = styled.div`
  width: 100%;
  height: 100%;
`;
